/**
 * The app state selectors
 */

import { createSelector } from 'reselect';
import { RootState } from 'store/store';

import { initialState } from './slice';

const selectAuth = (state: RootState) => state.authManagement || initialState;

const makeSelectLoading = () => createSelector(selectAuth, substate => substate.loading);
const makeSelectAuthenticated = () => createSelector(selectAuth, substate => substate.isAuthenticated);
const makeSelectError = () => createSelector(selectAuth, substate => substate.error);
const makeSelectChallengeUser = () => createSelector(selectAuth, substate => substate.challengeUser);

export { makeSelectLoading, makeSelectAuthenticated, makeSelectError, makeSelectChallengeUser };
